import React,{useState,useEffect,useContext} from 'react'
import { getAuth, signInWithPopup,signOut, GoogleAuthProvider, setPersistence ,browserSessionPersistence,browserLocalPersistence } from "firebase/auth";
import {provider} from "../firebase";
const AuthContext = React.createContext();
export function useAuth(){
    return useContext(AuthContext)
}

export  function AuthProvider({children}) {
  const [currentUser,setCurrentUser] = useState(); 
  function login(){
    const auth = getAuth();
    setPersistence(auth, browserLocalPersistence)
    .then(() => {
        if(currentUser === null || currentUser === undefined){

        
            signInWithPopup(auth, provider)
            .then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;
                // The signed-in user info.
                const user = result.user;
                setCurrentUser(user)
                // ...
            }).catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = GoogleAuthProvider.credentialFromError(error);
                console.log(error);
                console.log(errorMessage);
            });

            
        }
    });

  }
  const signout = ()=>{
    const auth = getAuth();
    signOut(auth).then(() => {
      setCurrentUser(null);
    }).catch((error) => {
      console.log("failed to signout");
    });
  }

  useEffect(()=>{

    getAuth().onAuthStateChanged((user) => {
        if (user) {
          // User is signed in, see docs for a list of available properties
          // https://firebase.google.com/docs/reference/js/firebase.User
          setCurrentUser(user)
          console.log(user.uid);
        } else {
          console.log("user is signed out");
        }
      });
  },[]); 
  const value = {
    currentUser,
    login,
    signout
  }
  return (
    <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>
  )
}
